import React from "react";

const BarChart = ({ HighchartsReact, Highcharts, data }) => {
  const regions = [
    "Northern Region",
    "Western Region",
    "Volta Region",
    "Eastern Region",
    "Upper East Region",
    "Upper West Region",
    "Ashanti Region",
    "Central Region",
    "Greater Accra Region",
    "North-East Region",
    "Oti Region",
    "Ahafo Region",
    "Bono Region",
    "Western North Region",
    "Savannah Region",
    "Bono East Region",
  ];

  const options = {
    colors: [
      "#6735A8",
      "#72ADFF",
      "#00C74C",
      "#FF6A3A",
      "#FFB53A",
      "#1e6c70",
      "#b01098",
      "#b0105d",
      "#edce05",
      "#ff0000",
      "#087478",
      "#2b5e07",
      "#690878",
      "#780839",
      "#177808",
      "#786308",
    ],
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
      enabled: false,
    },
    credits: {
      enabled: false,
    },

    tooltip: {
      formatter: function () {
        const sum = data.reduce((a, b) => a + b.y, 0);
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          "Total: " +
          this.y +
          "<br/>" +
          "Percentage: " +
          ((this.y / sum) * 100).toFixed(2) +
          "%"
        );
      },
    },
    xAxis: {
      categories: regions,
      crosshair: true,
      type: "category",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },

    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
      },
    },
    series: [
      {
        colorByPoint: true,
        data,
      },
    ],
  };

  return (
    <div className="md:px-0 py-5">
      {data && data.length < 1 ? (
        <>
          <div className="w-full flex justify-center mt-20 mb-20 ">
            <img src={require("../../../../assets/images/noData.svg")} alt="" />
          </div>
        </>
      ) : (
        <div className="mt-4">
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            updateArgs={[true, true, true]}
          />
        </div>
      )}
    </div>
  );
};

export default BarChart;
